import { computed } from "vue";
import { useOptionsValue } from "#ce/composables/useOptionsValue";

function toSortOption({ label, value, data }) {
  return { label, value, hint: data.sortHint || "" };
}

/**
 * The sort the element owns: the `<option>` children of the host as sort options, the host's `value`
 * property as the current sort. Mirrors the shape of `useSortSelect`.
 */
export function useSortOptions(config = {}) {
  const source = useOptionsValue(config);
  const options = computed(() => source.options.value.map(toSortOption));

  return { ...source, options };
}
